import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import DiamondBalanceAtom from '../../../recoil/cashout/DiamondBalanceAtom';
import { getProductFormattedNumber } from '../../helpers/CurrencyUtils';
import Diamond from '../../icons/Diamond';
import CashoutAwards from './common/CashoutAwards';
import { summarize } from '../../helpers/ProductUtils';

export default function CashoutCatalogPackages({ packages, onClick, disabled }) {
  const diamondBalance = useRecoilValue(DiamondBalanceAtom);

  const isPurchasable = (p) => p && (diamondBalance >= summarize(p.charges));

  return (
    <ul className="member-diamonds-to-credits" data-url="/cash-out/packages">
      {/* eslint-disable-next-line react/prop-types */}
      {packages.map((p) => (
        <li key={p.productId}>
          <div className="to-credits-coin-container">
            <span className="cashout-awards cashout-award-item">
              <CashoutAwards awards={p.awards} />
            </span>
          </div>
          <div className="cashout-package-button-container">
            <button type="button" className="btn btn-success btn-convert" onClick={() => { onClick(p); }} disabled={disabled || !isPurchasable(p)}>
              <div className="to-credits-diamond-wrapper">
                <div className="to-credits-diamond">
                  <Diamond />
                </div>
                <span>{getProductFormattedNumber(summarize(p.charges))}</span>
              </div>
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
}
CashoutCatalogPackages.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  packages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
CashoutCatalogPackages.defaultProps = {
  disabled: false,
};
